import { render, staticRenderFns } from "./GedModule.vue?vue&type=template&id=d7a046ea"
import script from "./GedModule.vue?vue&type=script&lang=js"
export * from "./GedModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports